import { render, staticRenderFns } from "./SideRecapItem.vue?vue&type=template&id=9cc70ccc"
import script from "./SideRecapItem.vue?vue&type=script&lang=ts"
export * from "./SideRecapItem.vue?vue&type=script&lang=ts"
import style0 from "./SideRecapItem.vue?vue&type=style&index=0&id=9cc70ccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports